
import * as Yup from 'yup';
import ValidationMessage from '../../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../../constants/Validation/ValidationMessageChange';
const local_language = localStorage.getItem('lang')

const ContactSupportValidation = Yup.object().shape({
  name: Yup.string().nullable(),
  // phonenumber: Yup.string().nullable(),

  // phone_number:Yup.string()
  // .required(ValidationMessage.Field("phone number"))
  // .min(7, ValidationMessage.VALID_PHONE_NUMBER)
  // .max(15, ValidationMessage.PHONE_MAX_CHAR)
  // .matches(/^[0-9]*$/, ValidationMessage.VALID_PHONE_NUMBER) // Allow only digits
  // .test('valid-phone', ValidationMessage.VALID_PHONE, value => {
  //   // Ensure phone number is not just repeated '0's
  //   if (!value) return true; // Return true if value is not provided (handled by required validation)

  //   if (/^0+$/.test(value)) {
  //     return false; // Reject if all characters are '0'
  //   }

  //   return true;
  // }),

  phone_number: Yup.string()
    .required(local_language == "alb" ? ValidationMessageAlbanian.Field("Numri i telefonit") : ValidationMessage.Field("phone number"))
    .min(7, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER)
    .max(15, local_language == "alb" ? ValidationMessageAlbanian.PHONE_MAX_CHAR : ValidationMessage.PHONE_MAX_CHAR)
    .matches(/^[0-9]*$/, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER) // Allow only digits
    .test('valid-phone', local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE : ValidationMessage.VALID_PHONE, value => {
      // Ensure phone number is not just repeated '0's
      if (!value) return true; // Return true if value is not provided (handled by required validation)

      if (/^0+$/.test(value)) {
        return false; // Reject if all characters are '0'
      }

      return true;
    }),

  email: Yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("email") : ValidationMessage.Field("email"))
    .email(local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
    .matches(ValidationMessage.EMAIL_REGREX, local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
    .trim(),
  // email: Yup.string().required(ValidationMessage.Field("email"))
  //     .email(ValidationMessage.EMAIL_ADDRESS)
  //     .matches(ValidationMessage.EMAIL_REGREX, ValidationMessage.EMAIL_ADDRESS)
  //     .max(150, ValidationMessage.MaxLength('Email', 150))
  //     .trim(),

  description: Yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("mesazh") : ValidationMessage.Field("message"))
    .min(30, local_language == "alb" ? ValidationMessageAlbanian.MinLength('përshkrim', 30) : ValidationMessage.MinLength('description', 50))
    .max(300, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('përshkrim', 300) : ValidationMessage.MaxLength('description', 300)),

});

export default ContactSupportValidation;
